import { IRootState } from '../../../store'
import { ICardioOptionsState } from '../store/options.types'

export const getCardioOptionsSelector = (state: IRootState): ICardioOptionsState => state.options.cardioOptions
